import React, {Component} from 'react';
import _ from 'lodash';
import {Route, Switch} from 'react-router-dom';

import {connect} from 'react-redux';

import {Toggle} from 'componentLibrary';
import {Loader} from 'semantic-ui-react';

import Home from 'go/pages/Home';
import GrantLandingPage from 'go/pages/GrantLandingPage';
import PanelReviewDashboardV2 from 'go/components/panelReview2/panelReviewDashboard';
import PanelReviewContainerV2 from 'go/components/panelReview2/panelReviewContainer';
import AdminConsole from 'go/components/modules/admin/AdminConsole';
import OrgProfilePage from 'go/components/orgProfile/orgProfileContainer';
import ProfilePage from 'go/components/profile/profileContainer';
import TeamPage from 'go/components/team/teamContainer';
import TeamManagement from 'go/components/team/teamManagement';
import TopNav from 'go/components/layout/topNav';
import TaskPage from 'go/pages/tasks/task';
import ThingsToDo from './pages/ThingsToDo/ThingsToDo';
import TaskSummary from 'go/pages/TaskSummary';
import Analytics from 'go/pages/Analytics';
import EntityPage from 'go/pages/EntityPage';
import Error from 'app-ui-componentlibrary/dist/go/components/common/error';

import UnauthorizedPage from 'go/pages/unauthorizedPage';
import CommentPage from 'go/pages/CommentPage';

import {
  canViewBucketTracker,
  canViewAwardsTracker,
  canViewPostAwardEntities,
  isSubAOR,
  canViewAnalytics,
  canViewSubGrantAmendmentsAndPayments,
  hasHMAprogramIds,
  hasInternalFundingOpIds,
  canViewTeamPage,
  isOnlyProgramExternal,
  hasRolesForRFI,
  hasGeneralPermission,
  canEditPropertyData,
} from 'go/security/permissions';

import {
  isFemaOrProgramExternal,
  isFemaUser,
  isProgramExternal,
  isRecipientUser,
} from 'common/utils';
import SearchResultsContainer from 'go/components/modules/searchResults/searchResultsContainer';
import TasksList from 'go/pages/TaskList';
import BulkTasksList from 'go/pages/BulkTaskList';

import BusinessObjectivesTracker from 'go/pages/tracker/businessObjectivesTracker';
import {SetAside} from 'go/pages/tracker/setAside';

import WorkloadDashboard from 'go/pages/workloadDashboard';
import Organizations from 'go/pages/Organizations';
import OrganizationsPage from 'go/pages/OrganizationsPage';
import OrganizationListAndSearchContainer from 'go/pages/subOrganization/OrganizationListAndSearchContainer';
import SubApplicationInitialize from 'go/components/subApplication/subApplicationInitialize';
import ApplicationInitialize from 'go/components/application/applicationInitialize';
import RfaInitialize from './components/rfa/rfaInitialize';
import FoInitialize from './components/fo/foInitialize';

import Grants from 'go/pages/grants/Grants';
import SubOrgGrants from 'go/pages/grants/SubOrgGrants';
import {
  hasAuthorizationToViewSubapplication,
  canViewAdminConsoleTab2,
} from 'go/security/permissions';
import SessionsList from './components/panelAdmin/sessionsList';
import PanelAdminContainer from './components/panelAdmin/PanelAdminContainer';

export const FEMAGO_UI_ROOT_URL = window.config
  ? window.config.femaGoRootUrl
  : process.env.REACT_APP_FEMAGO_UI_ROOT_URL;

export const ExternalRedirect = ({url}) => {
  React.useEffect(() => {
    window.location.replace(url);
  }, [url]);
  return null;
};

export class AuthRoutes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: props.permissions,
    };
  }

  render() {
    const {toggles = []} = this.props;

    const isSARorSM = !_.includes(toggles, 'manageTeamOrgSubOrg')
      ? true
      : isSubAOR(this.props.permissions);

    const programExternal = isOnlyProgramExternal(this.props.permissions);

    const subrecipientReviewPanelToggle = _.includes(toggles, 'GMMGO-12948');
    const panelReviewV2 = _.includes(toggles, 'panelReviewV2');
    const disasterSiteNav = _.includes(toggles, 'disasterSiteNav');

    // TODO put toggles check, don't load anything unless the toggles are loaded

    return (
      /* TODO add some sort of authentication for most of these so there's a graceful failure
       when users go to a page accidentally (bookmarked before a role change, sent a direct link)
       that they don't have permissions for. Security purposes too since some backend permissions aren't
       airtight like /checklist/. Redirect to unauthorized page instead. */
      <React.Fragment>
        <a href="#content" target="_self" className="usa-skipnav">
          Skip to Main Content
        </a>
        <TopNav includeAwareness={true} />
        <div className="sr-only">
          Information is automatically saved as fields are modified and focus is changed.
          You do not need to manually save data in FEMA GO.
        </div>
        <Switch>
          <Route exact path="/profile" component={ProfilePage} />
          <Route exact path="/organizationProfile/:id" component={OrgProfilePage} />
          <Route
            exact
            path="/grant/:grantNumber/:config"
            render={(props) =>
              canViewPostAwardEntities(this.props.permissions) ||
              isFemaUser(this.props.permissions) ? (
                <GrantLandingPage {...props} />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/grant/:grantNumber"
            render={(props) =>
              canViewPostAwardEntities(this.props.permissions) ||
              isFemaUser(this.props.permissions) ? (
                <GrantLandingPage {...props} />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/subGrant/:subGrantNumber"
            render={(props) =>
              (canViewSubGrantAmendmentsAndPayments(this.props.permissions) ||
                isFemaOrProgramExternal(this.props.permissions)) &&
              (hasHMAprogramIds(this.props.permissions) ||
                hasInternalFundingOpIds(this.props.permissions)) ? (
                <GrantLandingPage {...props} />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/subGrant/:subGrantNumber/:config"
            render={(props) =>
              canViewSubGrantAmendmentsAndPayments(this.props.permissions) ||
              isFemaOrProgramExternal(this.props.permissions) ? (
                <GrantLandingPage {...props} />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/panelReviewDashboard/:panelSessionId"
            component={!programExternal ? PanelReviewDashboardV2 : Error}
          />
          <Route
            exact
            path="/panelReview/sessions"
            render={(props) => (
              <Toggle toggle="panelReviewV2">
                <PanelReviewDashboardV2 {...props} />
              </Toggle>
            )}
          />
          <Route
            exact
            path="/panelReview/sessions/:sessionId/tasks"
            render={(props) => (
              <Toggle toggle="panelReviewV2">
                <PanelReviewDashboardV2 {...props} />
              </Toggle>
            )}
          />
          <Route
            exact
            path="/panelReview/sessions/:sessionId/tasks/:taskId"
            render={(props) => (
              <Toggle toggle="panelReviewV2">
                <PanelReviewContainerV2 {...props} />
              </Toggle>
            )}
          />
          <Route
            exact
            path="/panelReview/admin/sessions"
            render={(props) => (
              <Toggle toggle="panelAdmin">
                <SessionsList {...props}></SessionsList>
              </Toggle>
            )}
          />
          <Route
            exact
            path="/panelReview/admin/sessions/:panelSessionId/"
            render={(props) => (
              <Toggle toggle="panelAdmin">
                <PanelAdminContainer
                  key={`entityPage-parent-${props.match.params.panelSessionId}`}
                  {...props}
                  configType={'session'}
                  page={props.match.params.page}
                  sessionId={props.match.params.panelSessionId}
                ></PanelAdminContainer>
              </Toggle>
            )}
          />
          <Route
            exact
            path="/panelReview/admin/sessions/:panelSessionId/:configType/:entityId"
            render={(props) => {
              const {panelSessionId, configType, entityId} = props.match.params;
              return (
                <Toggle toggle="panelAdmin">
                  <PanelAdminContainer
                    {...props}
                    key={`entityPage-parent-${panelSessionId}-${configType}-${entityId}`}
                    configType={configType}
                    entityId={entityId}
                    sessionId={panelSessionId}
                  />
                </Toggle>
              );
            }}
          />
          <Route
            exact
            path="/team"
            component={
              hasGeneralPermission('TEAM_MANAGEMENT')
                ? TeamManagement
                : canViewTeamPage(this.props.permissions)
                ? TeamPage
                : Error
            }
          />
          <Route
            exact
            path="/:grantId/comments"
            component={!programExternal ? CommentPage : Error}
          />
          <Route exact path="/tasks/" render={(props) => <TaskSummary {...props} />} />
          <Route
            exact
            path="/panelReview/sessions/:sessionId/tasks/:taskId/view"
            render={(props) => (
              <Toggle toggle="panelReviewV2">
                <PanelReviewContainerV2 {...props} configType={'entityView'} />
              </Toggle>
            )}
          />
          <Route
            exact
            path="/:grantId/comments"
            component={!programExternal ? CommentPage : Error}
          />
          <Route exact path="/tasks/" render={(props) => <TaskSummary {...props} />} />
          <Route
            exact
            path="/thingsToDo/"
            render={(props) => <ThingsToDo {...props} />}
          />

          <Route
            exact
            path="/analytics/"
            render={(props) =>
              canViewAnalytics(this.props.permissions) ||
              hasGeneralPermission('ANALYTICS') ? (
                <Toggle toggle="analyticsRoute">
                  <Analytics {...props} />
                </Toggle>
              ) : (
                <Error {...props} />
              )
            }
          />

          {/* TODO, refactor to be more react router friendly */}
          <Route
            exact
            path="/amendment/:entityId/edit"
            render={(props) =>
              canViewPostAwardEntities(this.props.permissions) ? (
                <EntityPage
                  {...props}
                  entityType={'amendment'}
                  configType={'entityEdit'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/amendment/:entityId/view"
            render={(props) =>
              isFemaUser(this.props.permissions) ||
              canViewPostAwardEntities(this.props.permissions) ? (
                <EntityPage
                  {...props}
                  entityType={'amendment'}
                  configType={'entityView'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/application/:entityId/edit"
            render={(props) =>
              !isFemaOrProgramExternal(this.props.permissions) ? (
                <EntityPage
                  key={'applicationEdit'}
                  id={'applicationEdit'}
                  {...props}
                  entityType={'application'}
                  configType={'entityEdit'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/application/:entityId/view"
            render={(props) =>
              !isFemaOrProgramExternal(this.props.permissions) ? (
                <EntityPage
                  key={'applicationView'}
                  id={'applicationView'}
                  {...props}
                  entityType={'application'}
                  configType={'entityView'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/payment/:entityId/edit"
            render={(props) =>
              canViewPostAwardEntities(this.props.permissions) ? (
                <EntityPage {...props} entityType={'payment'} configType={'entityEdit'} />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/payment/:entityId/view"
            render={(props) =>
              isFemaUser(this.props.permissions) ||
              canViewPostAwardEntities(this.props.permissions) ? (
                <EntityPage {...props} entityType={'payment'} configType={'entityView'} />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/returnOfFund/:entityId/edit"
            render={(props) => (
              <EntityPage
                {...props}
                entityType={'returnOfFund'}
                configType={'entityEdit'}
              />
            )}
          />
          <Route
            exact
            path="/returnOfFund/:entityId/view"
            render={(props) => (
              <EntityPage
                {...props}
                entityType={'returnOfFund'}
                configType={'entityView'}
              />
            )}
          />
          <Route
            exact
            path="/closeoutReport/:entityId/edit"
            render={(props) =>
              canViewPostAwardEntities(this.props.permissions) ? (
                <EntityPage
                  {...props}
                  entityType={'closeoutReport'}
                  configType={'entityEdit'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/closeoutReport/:entityId/view"
            render={(props) =>
              isFemaUser(this.props.permissions) ||
              canViewPostAwardEntities(this.props.permissions) ? (
                <EntityPage
                  {...props}
                  entityType={'closeoutReport'}
                  configType={'entityView'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/subCloseoutReport/:entityId/edit"
            render={(props) =>
              canViewPostAwardEntities(this.props.permissions) ? (
                <EntityPage
                  {...props}
                  entityType={'subCloseoutReport'}
                  configType={'entityEdit'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/subCloseoutReport/:entityId/view"
            render={(props) =>
              isFemaUser(this.props.permissions) ||
              canViewPostAwardEntities(this.props.permissions) ? (
                <EntityPage
                  {...props}
                  entityType={'subCloseoutReport'}
                  configType={'entityView'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/propertyData/:entityId/edit"
            render={(props) =>
              canEditPropertyData(this.props.permissions) ? (
                <Toggle toggle="enablePropertyDataMitigation">
                  <EntityPage
                    {...props}
                    entityType={'propertyData'}
                    configType={'entityEdit'}
                  />
                </Toggle>
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/rfi/:entityId/view"
            render={(props) =>
              (canViewSubGrantAmendmentsAndPayments(this.props.permissions) ||
                isFemaOrProgramExternal(this.props.permissions)) &&
              hasHMAprogramIds(this.props.permissions) ? (
                <EntityPage {...props} entityType={'rfi'} configType={'entityView'} />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/financialReport/:entityId/view"
            render={(props) =>
              isFemaUser(this.props.permissions) ||
              canViewPostAwardEntities(this.props.permissions) ? (
                <EntityPage
                  {...props}
                  entityType={'financialReport'}
                  configType={'entityView'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/bsirReport/:entityId/view"
            render={(props) =>
              isFemaUser(this.props.permissions) ||
              canViewPostAwardEntities(this.props.permissions) ? (
                <EntityPage
                  {...props}
                  entityType={'bsirReport'}
                  configType={'entityView'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/fundingOpportunity/:entityId"
            render={(props) => {
              const referrerUrl = document.referrer ? new URL(document.referrer) : null;
              const publishedInFemaGo =
                (referrerUrl && referrerUrl.port !== window.location.port) ||
                sessionStorage.getItem('_femago_fo_pub_ack') === 'true';

              return isFemaUser(this.props.permissions) ||
                (isRecipientUser(this.props.permissions) && disasterSiteNav) ? (
                <EntityPage
                  key={'fundingOpportunityView'}
                  id={'fundingOpportunityView'}
                  {...props}
                  entityType={'fundingOpportunity'}
                  configType={'entityView'}
                  message={
                    publishedInFemaGo
                      ? 'You have successfully published the funding opportunity.'
                      : undefined
                  }
                />
              ) : (
                <Error {...props} />
              );
            }}
          />
          <Route
            exact
            path="/fundingOpportunity/draft/:entityId"
            render={(props) =>
              canViewAdminConsoleTab2(this.props.permissions) ? (
                <>
                  <Toggle toggle="adminConsole2">
                    <EntityPage
                      key={'fundingOpportunityEdit'}
                      id={'fundingOpportunityEdit'}
                      {...props}
                      entityType={'fundingOpportunityDraft'}
                      configType={'entityEdit'}
                    />
                  </Toggle>
                  <Toggle toggle="createFoV2">
                    <ExternalRedirect
                      url={`${FEMAGO_UI_ROOT_URL}fundingOpportunity/draft/${props.match.params.entityId}/edit`}
                    />
                  </Toggle>
                </>
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/allocation/:entityId/view"
            render={(props) =>
              isFemaUser(this.props.permissions) ? (
                <EntityPage
                  key={'allocationView'}
                  id={'allocationView'}
                  {...props}
                  entityType={'allocation'}
                  configType={'entityView'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/tasks/list"
            component={TasksList}
            render={(props) => <TasksList {...props} />}
          />
          <Route
            exact
            path="/tasks/bulk/list"
            component={BulkTasksList}
            render={(props) => <BulkTasksList {...props} />}
          />
          <Route
            exact
            path="/tasks/workload"
            component={WorkloadDashboard}
            render={(props) =>
              !programExternal || hasGeneralPermission('OFFICE_WORKLOAD_TRACKER') ? (
                <WorkloadDashboard {...props} />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route exact path="/tasks/:taskId" component={TaskPage} />
          <Route
            exact
            path="/awardsTracker"
            component={
              canViewAwardsTracker(this.props.permissions) ||
              hasGeneralPermission('BUSINESS_OBJECTIVES_TRACKER')
                ? BusinessObjectivesTracker
                : UnauthorizedPage
            }
          />
          <Route
            exact
            path="/awardsTracker/:targetId/trackerId/:trackerId/name/:name"
            component={SetAside}
          />
          <Route
            exact
            path="/search/:searchType/:searchQuery"
            component={SearchResultsContainer}
          />
          <Route
            exact
            path="/applicationInitialize/:fundingOpportunityId"
            render={(props) =>
              !programExternal ? (
                <ApplicationInitialize {...props} />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/application/:entityId"
            render={(props) =>
              !programExternal ? (
                <EntityPage
                  {...props}
                  entityType={'application'}
                  configType={'entityEdit'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/organizations"
            component={!programExternal ? Organizations : Error}
            render={(props) => <Organizations {...props} />}
          />
          <Route
            exact
            path="/organizations/:orgId"
            component={!programExternal ? Organizations : Error}
            render={(props) => <Organizations {...props} />}
          />
          <Route
            exact
            path="/organizationsPage"
            render={(props) => (
              <Toggle toggle="subOrganizationRoute">
                {!programExternal ? (
                  <OrganizationsPage {...props} />
                ) : (
                  <Error {...props} />
                )}
              </Toggle>
            )}
          />
          <Route
            exact
            path="/organizationsPage/:orgId"
            render={(props) => (
              <Toggle toggle="subOrganizationRoute">
                {!programExternal ? (
                  <OrganizationsPage {...props} />
                ) : (
                  <Error {...props} />
                )}
              </Toggle>
            )}
          />
          <Route
            exact
            path="/subOrganization/:orgId/:subOrgId"
            render={(props) => (
              <Toggle toggle="subOrganizationRoute">
                {!programExternal ? (
                  <OrganizationsPage {...props} />
                ) : (
                  <Error {...props} />
                )}
              </Toggle>
            )}
          />
          <Route
            exact
            path="/grants"
            render={(props) =>
              !programExternal ? (
                <Grants {...props} pageEntityType={'grant'} />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/subgrants"
            render={(props) => <SubOrgGrants {...props} pageEntityType={'subgrant'} />}
          />
          <Route
            exact
            path="/subApplication/:entityId"
            render={(props) =>
              !isFemaUser(this.props.permissions) && isSARorSM ? (
                <EntityPage
                  key={'subapplicationEdit'}
                  {...props}
                  entityType={'subApplication'}
                  configType={'entityEdit'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/subApplication/:entityId/edit"
            render={(props) =>
              !isFemaUser(this.props.permissions) && isSARorSM ? (
                <EntityPage
                  key={'subapplicationEdit'}
                  {...props}
                  entityType={'subApplication'}
                  configType={'entityEdit'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/subApplication/:entityId/view"
            render={(props) =>
              isFemaUser(this.props.permissions) ||
              isSARorSM ||
              hasAuthorizationToViewSubapplication(this.props.permissions) ? (
                <Toggle toggle="viewSubApplication">
                  <EntityPage
                    key={'subapplicationView'}
                    {...props}
                    entityType={'subApplication'}
                    configType={'entityView'}
                  />
                </Toggle>
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/subApplicationInitialize/:categoryId"
            render={(props) =>
              !programExternal ? (
                <SubApplicationInitialize {...props} />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/subApplicationInitialize/fo/:fundingOpportunityId"
            render={(props) =>
              !programExternal ? (
                <SubApplicationInitialize {...props} />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/rfaInitialize/fo/:fundingOpportunityId"
            render={(props) =>
              !programExternal ? <RfaInitialize {...props} /> : <Error {...props} />
            }
          />

          {/* START TODO/WIP:
              NOTE: This is a placeholder route, awaiting GMMGO-46600 implementation
              - Update config type to final one
              - Update EntityPage component to new FOinitialize component
          */}
          <Route
            exact
            path="/initialize/fo"
            render={(props) =>
              canViewAdminConsoleTab2(this.props.permissions) ? (
                <>
                  <Toggle toggle="adminConsole2">
                    <FoInitialize {...props} />
                  </Toggle>
                  <Toggle toggle="createFoV2">
                    <ExternalRedirect url={FEMAGO_UI_ROOT_URL + 'createFO'} />
                  </Toggle>
                </>
              ) : (
                <Error {...props} />
              )
            }
          />
          {/* END TODO/WIP */}

          <Route
            exact
            path="/rfa/:entityId"
            render={(props) =>
              !isFemaUser(this.props.permissions) && isSARorSM ? (
                <EntityPage
                  key={'rfaEdit'}
                  {...props}
                  entityType={'rfa'}
                  configType={'entityEdit'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/rfa/:entityId/edit"
            render={(props) =>
              !isFemaUser(this.props.permissions) && isSARorSM ? (
                <EntityPage
                  key={'rfaEdit'}
                  {...props}
                  entityType={'rfa'}
                  configType={'entityEdit'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/rfa/:entityId/view"
            render={(props) =>
              isFemaUser(this.props.permissions) ||
              isSARorSM ||
              hasAuthorizationToViewSubapplication(this.props.permissions) ? (
                <EntityPage
                  key={'rfaView'}
                  {...props}
                  entityType={'rfa'}
                  configType={'entityView'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />

          <Route
            exact
            path="/ehpReview/:entityId/view"
            render={(props) =>
              isFemaUser(this.props.permissions) ? (
                <EntityPage
                  key={'ehpReviewView'}
                  {...props}
                  entityType={'ehpReview'}
                  configType={'entityView'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />

          <Route
            exact
            path="/suborganizations"
            render={(props) =>
              !programExternal ? (
                <Toggle toggle="subOrganizationRoute">
                  <OrganizationListAndSearchContainer {...props} />
                </Toggle>
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/suborganizations/:orgId"
            render={(props) =>
              !programExternal ? (
                <Toggle toggle="subOrganizationRoute">
                  <OrganizationListAndSearchContainer {...props} />
                </Toggle>
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/admin/:configType"
            render={(props) => (
              <Toggle toggle="adminConsole">
                <AdminConsole {...props}></AdminConsole>
              </Toggle>
            )}
          />
          <Route
            exact
            path="/redirecting_page"
            render={(props) => <Loader active>Loading...</Loader>}
          />
          <Route
            exact
            path="/performanceProgressReport/:entityId/edit"
            render={(props) =>
              canViewPostAwardEntities(this.props.permissions) ? (
                <EntityPage
                  {...props}
                  entityType={'performanceProgressReport'}
                  configType={'entityEdit'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/performanceProgressReport/:entityId/view"
            render={(props) =>
              isFemaUser(this.props.permissions) ||
              canViewPostAwardEntities(this.props.permissions) ? (
                <EntityPage
                  {...props}
                  entityType={'performanceProgressReport'}
                  configType={'entityView'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/subAmendmentRecommendation/:entityId/view"
            render={(props) =>
              isFemaUser(this.props.permissions) ||
              canViewPostAwardEntities(this.props.permissions) ? (
                <EntityPage
                  {...props}
                  entityType={'subAmendmentRecommendation'}
                  configType={'entityView'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route
            exact
            path="/subAmendmentRecommendation/:entityId/edit"
            render={(props) =>
              canViewPostAwardEntities(this.props.permissions) ? (
                <EntityPage
                  {...props}
                  entityType={'subAmendmentRecommendation'}
                  configType={'entityEdit'}
                />
              ) : (
                <Error {...props} />
              )
            }
          />
          <Route component={Home} />
        </Switch>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    permissions: state.auth ? state.auth.permissions : [],
    toggles: state.toggles.toggles,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(AuthRoutes);
